// Environment-based API URL configuration
const getApiBaseUrl = () => {
  switch (process.env.REACT_APP_ENV) {
    case 'development':
      return 'http://localhost:5003';
    case 'staging':
      return 'http://194.76.27.9:5050';
    case 'production':
      return 'https://forecast-api.strategizer.lk';
    default:
      return 'https://forecast-api.strategizer.lk'; // Default to production
  }
};

const API_BASE_URL = getApiBaseUrl();

export const GetPredictionPlansApi = async (performanceCycleId = null) => {
  let res = "";
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
    };
    
    const url = performanceCycleId 
      ? `${API_BASE_URL}/v1/prediction/plans?performance_cycle_id=${performanceCycleId}`
      : `${API_BASE_URL}/v1/prediction/plans`;
      
    await fetch(url, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error: ", error);
        res = { success: false, message: error.message || 'Failed to fetch plans' };
      });
  } catch (error) {
    console.error(error);
    res = { success: false, message: error.message || 'Failed to fetch plans' };
  }

  return res;
};

export const GetPredictionModelsApi = async () => {
  let res = "";
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
    };
    await fetch(
      `${API_BASE_URL}/v1/prediction/models`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error: ", error);
        res = { success: false, message: error.message || 'Failed to fetch models' };
      });
  } catch (error) {
    console.error(error);
    res = { success: false, message: error.message || 'Failed to fetch models' };
  }

  return res;
};

export const RunPredictionApi = async (planTitle, modelType) => {
  let res = "";
  try {
    const body = {
      planTitle: planTitle,
      modelType: modelType,
    };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${API_BASE_URL}/v1/prediction/calculate`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error: ", error);
        res = { success: false, message: error.message || 'Failed to run prediction' };
      });
  } catch (error) {
    console.error(error);
    res = { success: false, message: error.message || 'Failed to run prediction' };
  }

  return res;
};

export const GetPlanProgressApi = async (planId) => {
  let res = "";
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
    };
    await fetch(
      `${API_BASE_URL}/v1/prediction/progress/${planId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error: ", error);
        res = { success: false, message: error.message || 'Failed to fetch plan progress' };
      });
  } catch (error) {
    console.error(error);
    res = { success: false, message: error.message || 'Failed to fetch plan progress' };
  }

  return res;
}; 